import PageShell from '@/components/feature/PageShell';
import useSeo from '@/hooks/useSeo';
import HeroSection from '@/pages/home/components/HeroSection';
import LatestReports from '@/pages/home/components/LatestReports';
import FeaturedStories from '@/pages/home/components/FeaturedStories';
import StatsBand from '@/pages/home/components/StatsBand';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutTeaser from '@/pages/home/components/AboutTeaser';
import { articles, faqs, siteInfo } from '@/mocks/incidents';

export default function Home() {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'WebSite',
        name: siteInfo.name,
        description: siteInfo.description,
        url: 'https://thcihd.cn/',
        inLanguage: 'zh-CN',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://thcihd.cn/cases?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'Organization',
        name: siteInfo.name,
        description: siteInfo.tagline,
        email: siteInfo.email,
        url: 'https://thcihd.cn/',
      },
      {
        '@type': 'ItemList',
        name: '正在追踪的重点条目',
        itemListElement: articles.slice(0, 6).map((item, index) => ({
          '@type': 'ListItem',
          position: index + 1,
          name: item.title,
          url: `https://thcihd.cn/cases/${item.id}`,
        })),
      },
      {
        '@type': 'FAQPage',
        mainEntity: faqs.map((item) => ({
          '@type': 'Question',
          name: item.q,
          acceptedAnswer: { '@type': 'Answer', text: item.a },
        })),
      },
    ],
  };

  useSeo({
    title: '缅北黑料｜事件案件通报·抓捕解救新闻汇总',
    description:
      '缅北黑料持续跟踪缅北相关事件、案件、新闻、通报、抓捕与解救进展，按时间线汇总公开报道与权威信息，帮你掌握跨境犯罪打击动态，提升反诈识别能力。',
    keywords: '缅北黑料,缅北黑料事件,缅北黑料案件,缅北黑料新闻,缅北黑料通报,缅北黑料抓捕,缅北黑料解救',
    path: '/',
    jsonLd,
  });

  return (
    <PageShell>
      <HeroSection />
      <LatestReports />
      <FeaturedStories />
      <StatsBand />
      <FaqSection />
      <AboutTeaser />
    </PageShell>
  );
}